import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_FEED] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.feed = payload
  },
  [types.SET_FEEDS] (state, payload) {
    state.feeds = payload.data
    state.pagination = payload.meta.pagination
  }
}
